/* ============================================================
 * Amorf Save Design — v1.0
 * "Tasarımımı Kaydet" — SMS / Mail ile kişiye özel tasarım linki
 * Backend: dolcevita-massimo.ngrok.io
 *   POST /save-design        → tasarımı kaydet + SMS/mail gönder
 *   GET  /saved-design/:id   → restore için state çek
 * ============================================================ */
(function () {
  'use strict';

  var API_BASE = 'https://dolcevita-massimo.ngrok.io/api';
  var STORE_DOMAIN = 'dolcevitahali.com';
  var FAB_ID = 'amorf-save-fab';
  var MODAL_ID = 'amorf-save-modal';
  var SS_KEY_AUTOSHOWN = 'amorf_save_autoshown_v1';
  var SS_KEY_USER = 'amorf_save_user_v1';
  var QS_PARAM = 'dv';

  // -------------------- STATE CAPTURE --------------------
  function captureState() {
    var s = { v: 1, ts: Date.now() };

    // URL / product
    s.url = location.pathname;
    s.handle = (location.pathname.split('/products/')[1] || '').split('?')[0];
    // Önce sayfa H1'i (variant adını içerir), olmazsa document.title fallback
    var titleEl = document.querySelector(
      '.product__title, .product-info__title, h1.product-single__title, ' +
      '.hdt-product__title, .product-meta__title, h1[itemprop="name"], ' +
      'h1[class*="product"][class*="title"], .product-title h1, h1.h1, h1'
    );
    var pageTitle = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
    if (pageTitle) {
      s.title = pageTitle;
    } else {
      s.title = (document.title || '').split(' – ')[0].split(' | ')[0].trim();
    }

    // Edge
    var edgeR = document.querySelector('input[name="ozel-olcu-edge"]:checked');
    s.edgeType = edgeR ? edgeR.value : null;

    // Kumaş (data-color-id active button)
    var colorBtn = document.querySelector('#ozel-olcu-color-options .ozel-olcu-plus__color-btn.active');
    if (colorBtn) {
      s.kumasId = colorBtn.dataset.colorId || null;
      s.kumasLabel = colorBtn.title || (colorBtn.querySelector('.ozel-olcu-plus__color-name') || {}).textContent || null;
      var img = colorBtn.querySelector('img');
      if (img && img.src) s.kumasImg = img.src;
      // Dominant rengi yakala (style/bg veya getComputedStyle)
      try {
        var swatch = colorBtn.querySelector('[style*="background"]') || colorBtn;
        var bg = swatch.style.backgroundColor || getComputedStyle(swatch).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') s.kumasColor = bg;
      } catch (e) {}
    }
    // Halı kalitesi/desen görseli (ana ürün resmi)
    var mainImg = document.querySelector('#bp-main-image img, .bp-gallery__main img, .product__media img');
    if (mainImg && mainImg.src) s.patternImg = mainImg.src;

    // Dimensions
    var w = document.getElementById('ozel-olcu-width');
    var l = document.getElementById('ozel-olcu-length');
    s.widthCm = w && w.value ? parseInt(w.value, 10) : null;
    s.lengthCm = l && l.value ? parseInt(l.value, 10) : null;

    // Shape
    var shapeSel = document.getElementById('ozel-olcu-shape');
    s.shape = shapeSel ? shapeSel.value : 'dikdortgen';

    // Amorf detail
    if (s.shape === 'amorf' && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
      try {
        var sh = window.__OzelOlcuAmorf.getShape();
        if (sh) {
          s.amorf = {
            presetIdx: typeof sh.presetIdx === 'number' ? sh.presetIdx : -1,
            presetLabel: sh.presetLabel || null,
            radii: sh.radii ? Array.prototype.slice.call(sh.radii) : null,
            area: sh.area || null,
            perimeter: sh.perimeter || null
          };
        }
      } catch (e) {}
    }

    // Preview snapshot — amorf/dikdörtgen tüm ürünler için kalıcı çözüm
    try { s.previewImg = capturePreviewDataUrl(640); } catch (e) {}

    // Kalite/desen — handle'dan tahmin
    if (s.handle) {
      var parts = s.handle.split('-');
      s.kalite = parts[2] || parts[0] || null;
      s.desen = s.handle.replace(/-ozel-olcu$/, '');
    }

    return s;
  }

  // -------------------- STATE RESTORE --------------------
  function showRestoreOverlay() {
    if (document.getElementById('amorf-restore-ovl')) return;
    var wrap = document.querySelector('#ozel-olcu-preview-wrapper, .ozel-olcu-preview-wrapper, .ozel-olcu-preview, [class*="preview-wrapper"]')
            || document.body;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    // Preview altındaki canvas/svg'yi gizle — geçiş sızmasın
    try {
      var hideTargets = wrap.querySelectorAll('canvas, svg, img, .ozel-olcu-amorf-canvas, [class*="amorf"]');
      hideTargets.forEach(function(el){ el.dataset.amorfPrevVis = el.style.visibility || ''; el.style.visibility = 'hidden'; });
    } catch(e){}
    var ovl = document.createElement('div');
    ovl.id = 'amorf-restore-ovl';
    ovl.style.cssText = 'position:absolute;inset:0;background:#ffffff;z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;font-family:-apple-system,Helvetica,Arial,sans-serif;transition:opacity .4s ease;';
    ovl.innerHTML =
      '<div style="width:54px;height:54px;border:3px solid #f5e6dc;border-top-color:#e8622a;border-radius:50%;animation:amorfSpin 0.9s linear infinite"></div>' +
      '<div style="font-size:15px;color:#222;font-weight:600;letter-spacing:.2px">Halı tasarımınız oluşturuluyor</div>' +
      '<div style="font-size:12px;color:#999;font-weight:400">Birkaç saniye sürebilir, lütfen bekleyin…</div>' +
      '<style>@keyframes amorfSpin{to{transform:rotate(360deg)}}</style>';
    wrap.appendChild(ovl);
  }
  function hideRestoreOverlay() {
    var ovl = document.getElementById('amorf-restore-ovl');
    if (!ovl) return;
    var wrap = ovl.parentNode;
    ovl.style.opacity = '0';
    setTimeout(function(){
      if (ovl.parentNode) ovl.parentNode.removeChild(ovl);
      // Gizlenen elementleri geri aç
      try {
        if (wrap) wrap.querySelectorAll('[data-amorf-prev-vis], canvas, svg, img').forEach(function(el){
          el.style.visibility = el.dataset.amorfPrevVis || '';
          delete el.dataset.amorfPrevVis;
        });
      } catch(e){}
    }, 380);
  }

  function applyState(s) {
    if (!s) return;
    try { console.log('[AMORF-RESTORE] state=', JSON.stringify(s)); } catch(e){}
    window.__lastRestoreState = s;
    showRestoreOverlay();
    // 6 sn opak overlay (amorf için) — editor random preset/normalize/reset döngüsü tamamlansın
    setTimeout(hideRestoreOverlay, (s && s.shape === 'amorf') ? 6000 : 1800);

    // 1) Edge
    if (s.edgeType) {
      var er = document.querySelector('input[name="ozel-olcu-edge"][value="' + s.edgeType + '"]');
      if (er && !er.checked) {
        er.checked = true;
        er.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // 2) Dimensions
    setTimeout(function () {
      if (s.widthCm) setInputValue('ozel-olcu-width', s.widthCm);
      if (s.lengthCm) setInputValue('ozel-olcu-length', s.lengthCm);
    }, 200);

    // 3) Shape buttons
    if (s.shape) {
      setTimeout(function () {
        var btn = document.querySelector('.bp-shape-btn[data-shape="' + s.shape + '"]');
        if (btn && !btn.classList.contains('active')) btn.click();
      }, 400);
    }

    // 4) Amorf preset + radii (mail'deki BIREBIR şekli geri yükle)
    if (s.shape === 'amorf' && s.amorf) {
      var savedRadii = s.amorf.radii && s.amorf.radii.length ? s.amorf.radii : null;
      var savedIdx = (typeof s.amorf.presetIdx === 'number') ? s.amorf.presetIdx : -1;
      window.__amorfSkipRandomPreset = true;
      window.__amorfRestoreActive = true;
      window.__amorfRestoreRadii = savedRadii;

      // Periyodik radii enforcer — 3 saniye boyunca her 250ms'de bir radii'yi zorla
      // (editor sonradan init olup random preset üretiyor — biz son söz olalım)
      var enforceCount = 0;
      var enforceMax = 30; // 30 * 200ms = 6 sn
      function enforceRadii() {
        var api = window.__OzelOlcuAmorf;
        if (!api) return;
        try {
          if (savedRadii && api.setRadii) api.setRadii(savedRadii);
          if (s.widthCm && s.lengthCm && api.setDimensions) api.setDimensions(s.widthCm, s.lengthCm);
        } catch (e) {}
      }

      var triesA = 0;
      var ivA = setInterval(function () {
        triesA++;
        var api = window.__OzelOlcuAmorf;
        if (api && (api.setRadii || api.loadPreset)) {
          if (savedRadii && api.setRadii) {
            enforceRadii();
            try { console.log('[AMORF-RESTORE] radii uygulandi (', savedRadii.length, ' nokta ) — enforcer aktif'); } catch(e){}
            // Enforcer başlat — 6 saniye boyunca radii'yi koru
            var enforcerIv = setInterval(function () {
              enforceCount++;
              enforceRadii();
              if (enforceCount >= enforceMax) {
                clearInterval(enforcerIv);
                window.__amorfRestoreActive = false;
                try { console.log('[AMORF-RESTORE] enforcer tamamlandi'); } catch(e){}
              }
            }, 200);
          } else if (savedIdx >= 0 && api.loadPreset) {
            try { api.loadPreset(savedIdx); } catch (e) {}
          }
          clearInterval(ivA);
          setTimeout(function () { window.__amorfSkipRandomPreset = false; }, 3500);
        } else if (triesA > 40) {
          clearInterval(ivA);
          window.__amorfSkipRandomPreset = false;
          window.__amorfRestoreActive = false;
        }
      }, 100);
    }

    // 5) Kumaş — son sırada (renderBiyeColors edge'e bağlı çalışır)
    if (s.kumasId) {
      var tries2 = 0;
      var iv2 = setInterval(function () {
        tries2++;
        var cBtn = document.querySelector('#ozel-olcu-color-options .ozel-olcu-plus__color-btn[data-color-id="' + s.kumasId + '"]');
        if (cBtn) {
          if (!cBtn.classList.contains('active')) cBtn.click();
          clearInterval(iv2);
        } else if (tries2 > 40) {
          clearInterval(iv2);
        }
      }, 250);
    }

    // 6) Restore göstergesi (toast)
    setTimeout(function () { showToast('✓ Kaydedilen tasarımın yüklendi'); }, 800);
  }

  function setInputValue(id, val) {
    var el = document.getElementById(id);
    if (!el) return;
    el.value = String(val);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // -------------------- URL HELPERS --------------------
  function tryRestoreFromUrl() {
    var sp = new URLSearchParams(location.search);
    var id = sp.get(QS_PARAM);
    if (!id) return;
    // Spinner'i HEMEN goster — fetch beklemeden, kullanici dikdörtgen flash'ı görmesin
    try { showRestoreOverlay(); } catch(e){}
    // Guvenli emniyet — 8 sn sonra her halukarda kapat
    setTimeout(function(){ try { hideRestoreOverlay(); } catch(e){} }, 8000);
    fetch(API_BASE + '/saved-design/' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.state) return;
        // Aynı handle ise state'i uygula
        if (d.state.handle && d.state.handle === (location.pathname.split('/products/')[1] || '').split('?')[0]) {
          applyState(d.state);
        } else {
          // Farklı ürün — KULLANICIYI ZORLA YÖNLENDİRME (yıkıcı UX).
          // Sadece eski URL paramını temizle ki bir daha tetiklenmesin.
          try {
            var u = new URL(location.href);
            u.searchParams.delete(QS_PARAM);
            history.replaceState(null, '', u.toString());
          } catch (e) {}
          console.warn('[AmorfSave] Kayıtlı tasarım farklı ürün için (' + d.state.handle + '), atlandı.');
        }
      })
      .catch(function () {});
  }

  // -------------------- TOAST --------------------
  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'amorf-save-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('show'); }, 20);
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { t.remove(); }, 300);
    }, 3500);
  }

  // -------------------- FAB --------------------
  // Buton, görünür bir ürün-resim kapsayıcısının sağ-üst köşesine yerleşir.
  // Önce canlı önizleme alanı; yoksa ana ürün galerisi köşesi.
  // 800ms boyunca görünür bir host bulunamazsa fixed bottom-right fallback.
  function findVisibleHost() {
    var candidates = [
      '#ozel-olcu-preview-wrapper',
      '#bp-main-image',
      '.product-gallery',
      '.product__media-wrapper',
      '.product__media-list',
      '.product__media',
      '.product-media'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.offsetWidth > 50 && el.offsetHeight > 50) return el;
    }
    return null;
  }

  function makeFabBtn(className) {
    var b = document.createElement('button');
    b.id = FAB_ID;
    b.className = className;
    b.type = 'button';
    b.setAttribute('aria-label', 'Tasarımımı Kaydet');
    b.innerHTML =
      '<span class="amorf-save-fab__ic">🔖</span>' +
      '<span class="amorf-save-fab__tx">Tasarımımı Kaydet</span>';
    b.addEventListener('click', function () { openModal(); });
    return b;
  }

  function placeFabInForm() {
    // Önce "Sepete Ekle" butonunu bul, hemen üstüne ekle
    var addToCartBtn = document.getElementById('ozel-olcu-add-to-cart');
    if (addToCartBtn && addToCartBtn.parentElement) {
      var wrap = document.createElement('div');
      wrap.className = 'amorf-save-fab-wrap';
      wrap.appendChild(makeFabBtn('amorf-save-fab amorf-save-fab--inline'));
      addToCartBtn.parentElement.insertBefore(wrap, addToCartBtn);
      return true;
    }
    // Fallback: form container'ının altına
    var form = document.getElementById('ozel-olcu-plus') || document.querySelector('.hdt-product__form, .product-form, [data-type="add-to-cart-form"]');
    if (form) {
      var wrap2 = document.createElement('div');
      wrap2.className = 'amorf-save-fab-wrap';
      wrap2.appendChild(makeFabBtn('amorf-save-fab amorf-save-fab--inline'));
      form.appendChild(wrap2);
      return true;
    }
    return false;
  }

  function buildInlineButton() {
    var b = document.createElement('button');
    b.type = 'button';
    b.id = FAB_ID;
    b.setAttribute('aria-label', 'Tasarımımı Kaydet');
    b.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:10px;flex-shrink:0;"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>' +
      '<span>Tasarımımı Kaydet</span>';
    b.style.cssText = [
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'width:100%',
      'box-sizing:border-box',
      'padding:14px 20px',
      'margin:0',
      'background:#fff',
      'border:1.5px solid #e8622a',
      'border-radius:8px',
      'color:#e8622a',
      'font-family:inherit',
      'font-size:13px',
      'font-weight:600',
      'letter-spacing:1px',
      'text-transform:uppercase',
      'cursor:pointer',
      'transition:background .15s ease, color .15s ease',
      'visibility:visible',
      'opacity:1'
    ].join(';');
    b.addEventListener('mouseenter', function () {
      b.style.background = '#e8622a';
      b.style.color = '#fff';
    });
    b.addEventListener('mouseleave', function () {
      b.style.background = '#fff';
      b.style.color = '#e8622a';
    });
    b.addEventListener('click', openModal);
    return b;
  }

  function findAddToCartButton() {
    // Sırayla en olası selector'ları dene
    var selectors = [
      '#ozel-olcu-add-to-cart',
      '.hdt-product__form button[type="submit"]',
      '.product-form__submit',
      '.product-form button[name="add"]',
      'button[name="add"]',
      'form[action*="/cart/add"] button[type="submit"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.offsetHeight > 0) return el;
    }
    return null;
  }

  function placeFabInline() {
    if (document.getElementById(FAB_ID)) return true;
    var addBtn = findAddToCartButton();
    if (!addBtn) return false;
    var wrap = document.createElement('div');
    wrap.className = 'amorf-save-fab-wrap';
    wrap.style.cssText = 'margin:0 0 10px;width:100%;box-sizing:border-box;';
    wrap.appendChild(buildInlineButton());
    // "Sepete Ekle" butonunun parent container'ını bul, onun üstüne ekle
    // Eğer buton bir form içinde ise form'un üstüne, değilse direkt buton üstüne
    var parent = addBtn.parentElement;
    parent.insertBefore(wrap, addBtn);
    console.log('[AmorfSaveDesign] FAB inline placed above:', addBtn.id || addBtn.className);
    return true;
  }

  function injectFab() {
    if (document.getElementById(FAB_ID)) return;
    if (placeFabInline()) return;
    // "Sepete Ekle" henüz yüklenmediyse 400ms aralıklarla 15 kez dene (~6sn)
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.getElementById(FAB_ID)) { clearInterval(iv); return; }
      if (placeFabInline()) { clearInterval(iv); return; }
      if (tries >= 15) { clearInterval(iv); console.warn('[AmorfSaveDesign] Sepete Ekle butonu bulunamadı'); }
    }, 400);
  }

  function watchHostVisibility(host) {
    // Eğer host sonradan gizlenirse, FAB'ı başka host'a taşı
    setInterval(function () {
      var fab = document.getElementById(FAB_ID);
      if (!fab) { injectFab(); return; }
      if (fab.offsetWidth === 0) {
        fab.remove();
        injectFab();
      }
    }, 1500);
  }

  // -------------------- AUTO-SHOW --------------------
  // Kullanıcı kalite + kenar + kumaş + ölçü + şekil seçtiyse, sayfada 30sn
  // geçince modal otomatik 1 kez açılır.
  function maybeAutoShow() {
    try {
      if (sessionStorage.getItem(SS_KEY_AUTOSHOWN)) return;
    } catch (e) {}
    var s = captureState();
    var ready = s.edgeType && s.widthCm > 0 && s.lengthCm > 0 && s.shape && s.kumasId;
    if (!ready) return;
    try { sessionStorage.setItem(SS_KEY_AUTOSHOWN, '1'); } catch (e) {}
    openModal(true);
  }

  function scheduleAutoShow() {
    var firstReadyAt = null;
    setInterval(function () {
      try { if (sessionStorage.getItem(SS_KEY_AUTOSHOWN)) return; } catch (e) {}
      if (document.getElementById(MODAL_ID)) return; // zaten açık
      var s = captureState();
      var ready = s.edgeType && s.widthCm > 0 && s.lengthCm > 0 && s.shape && s.kumasId;
      if (!ready) { firstReadyAt = null; return; }
      if (!firstReadyAt) firstReadyAt = Date.now();
      // Kullanıcı seçimleri tamamladıktan 25sn sonra modal aç
      if (Date.now() - firstReadyAt > 25000) maybeAutoShow();
    }, 3000);
  }

  // -------------------- MODAL --------------------
  function openModal(isAuto) {
    var existing = document.getElementById(MODAL_ID);
    if (existing) { existing.style.display = 'flex'; return; }

    var st = captureState();
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(SS_KEY_USER) || '{}'); } catch (e) {}

    var summary = buildSummaryHtml(st);
    var autoBadge = isAuto
      ? '<div class="amorf-save-modal__autobadge">✨ Tasarımın hazır görünüyor — kaybetme!</div>'
      : '';

    var html =
      '<div class="amorf-save-modal__backdrop"></div>' +
      '<div class="amorf-save-modal__box" role="dialog" aria-modal="true" aria-labelledby="amorf-save-title">' +
        '<button type="button" class="amorf-save-modal__close" aria-label="Kapat">×</button>' +
        autoBadge +
        '<div class="amorf-save-modal__brand">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/dolce-vita-logo.png" alt="Dolce Vita Halı" class="amorf-save-modal__brand-logo">' +
        '</div>' +
        '<h3 id="amorf-save-title" class="amorf-save-modal__title">Tasarımımı Kaydet</h3>' +
        '<p class="amorf-save-modal__sub">Bu özel tasarımını kendine SMS veya e-posta ile gönder. Daha sonra istediğin zaman aynı sayfayı açıp sepete ekleyebilirsin.</p>' +
        summary +
        '<form class="amorf-save-form" id="amorf-save-form" novalidate>' +
          '<div class="amorf-save-row amorf-save-row--2">' +
            '<label class="amorf-save-field">' +
              '<span>Ad <em>*</em></span>' +
              '<input type="text" name="ad" autocomplete="given-name" required value="' + esc(saved.ad || '') + '">' +
            '</label>' +
            '<label class="amorf-save-field">' +
              '<span>Soyad <em>*</em></span>' +
              '<input type="text" name="soyad" autocomplete="family-name" required value="' + esc(saved.soyad || '') + '">' +
            '</label>' +
          '</div>' +
          '<div class="amorf-save-channel">' +
            '<div class="amorf-save-channel__hd">Linki nasıl alacaksın? <em>*</em></div>' +
            '<div class="amorf-save-channel__btns">' +
              '<label class="amorf-save-channel__opt"><input type="radio" name="kanal" value="sms" checked><span>📱 SMS</span></label>' +
              '<label class="amorf-save-channel__opt"><input type="radio" name="kanal" value="mail"><span>✉️ E-Posta</span></label>' +
              '<label class="amorf-save-channel__opt"><input type="radio" name="kanal" value="both"><span>📱 + ✉️ İkisi</span></label>' +
            '</div>' +
          '</div>' +
          '<div class="amorf-save-row amorf-save-row--2" id="amorf-save-contacts">' +
            '<label class="amorf-save-field" data-need="sms">' +
              '<span>Cep Telefonu <em>*</em></span>' +
              '<input type="tel" name="tel" placeholder="05XX XXX XX XX" maxlength="15" autocomplete="tel" value="' + esc(saved.tel || '') + '">' +
            '</label>' +
            '<label class="amorf-save-field" data-need="mail" style="display:none;">' +
              '<span>E-Posta <em>*</em></span>' +
              '<input type="email" name="mail" placeholder="ornek@mail.com" autocomplete="email" value="' + esc(saved.mail || '') + '">' +
            '</label>' +
          '</div>' +
          '<label class="amorf-save-consent">' +
            '<input type="checkbox" name="consent" required>' +
            '<span>Tasarım linkimin tarafıma gönderilmesini ve <a href="/policies/privacy-policy" target="_blank">KVKK aydınlatma metnini</a> okuduğumu kabul ediyorum.</span>' +
          '</label>' +
          '<div class="amorf-save-err" id="amorf-save-err"></div>' +
          '<button type="submit" class="amorf-save-submit">Tasarımımı Gönder</button>' +
        '</form>' +
        '<div class="amorf-save-modal__powered">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/dolce-vita-logo.png" alt="Dolce Vita Halı" class="amorf-save-modal__powered-logo">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/massimo-logo.png" alt="Massimo" class="amorf-save-modal__powered-logo">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/dolce-vita-home-logo.png" alt="Dolce Vita Home" class="amorf-save-modal__powered-logo">' +
        '</div>' +
      '</div>';

    var wrap = document.createElement('div');
    wrap.id = MODAL_ID;
    wrap.className = 'amorf-save-modal';
    wrap.innerHTML = html;
    document.body.appendChild(wrap);
    document.body.style.overflow = 'hidden';

    bindModal(wrap, st);
  }

  function closeModal() {
    var m = document.getElementById(MODAL_ID);
    if (m) m.remove();
    document.body.style.overflow = '';
  }

  function buildSummaryHtml(st) {
    // Halı önizlemesi — amorf/dikdörtgen tüm ürünler için tek helper
    var preview = '';
    try {
      var dataUrl = capturePreviewDataUrl(640);
      if (dataUrl) preview = '<img class="amorf-save-photo" src="' + dataUrl + '" alt="Halı önizleme" />';
    } catch (e) {}
    if (!preview) preview = buildShapeSvg(st);
    var biyeColor = st.kumasColor || '#e8622a';
    var chips = [];
    if (st.shape) chips.push({ ic: shapeIcon(st.shape), tx: shapeName(st.shape) + (st.amorf && st.amorf.presetLabel ? ' · ' + st.amorf.presetLabel : '') });
    if (st.widthCm && st.lengthCm) chips.push({ ic: '📐', tx: st.widthCm + ' × ' + st.lengthCm + ' cm' });
    if (st.edgeType) chips.push({ ic: '✦', tx: edgeName(st.edgeType) });
    if (st.kumasLabel || st.kumasId) chips.push({
      ic: '<span class="amorf-save-dot" style="background:' + esc(biyeColor) + '"></span>',
      tx: 'Kumaş: ' + (st.kumasLabel || st.kumasId)
    });

    return '<div class="amorf-save-card">' +
      '<div class="amorf-save-card__preview">' + preview + '</div>' +
      '<div class="amorf-save-card__info">' +
        (st.title ? '<div class="amorf-save-card__title">' + esc(st.title) + '</div>' : '') +
        '<div class="amorf-save-card__chips">' +
          chips.map(function (c) {
            return '<span class="amorf-save-chip"><span class="amorf-save-chip__ic">' + c.ic + '</span>' + esc(c.tx) + '</span>';
          }).join('') +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // Kullanıcı tasarımının SVG önizlemesi (CORS-safe, her zaman güzel)
  // Halı önizlemesini görüntüden yakala — amorf, plus, dikdörtgen tüm ürünler için tek noktadan
  // Öncelik:
  //   1) Amorf motoru: #ozel-olcu-amorf-canvas (DOM'daki rendered canvas)
  //   2) Plus/dikdörtgen motoru: __ozelOlcuPreview.getPreviewDataUrl()
  //   3) Sayfada bulunan herhangi bir preview canvas
  //   4) Plus motoru CDN cart-preview URL'i
  //   5) #bp-main-image içindeki ana ürün görseli (en son çare)
  function capturePreviewDataUrl(maxW) {
    maxW = maxW || 640;
    function fromCanvas(cvs) {
      if (!cvs || !cvs.toDataURL || !cvs.width || !cvs.height) return null;
      try {
        var ratio = cvs.height / cvs.width;
        var w = Math.min(maxW, cvs.width);
        var h = Math.round(w * ratio);
        var out = document.createElement('canvas');
        out.width = w; out.height = h;
        var cx = out.getContext('2d');
        cx.fillStyle = '#ffffff';
        cx.fillRect(0, 0, w, h);
        cx.drawImage(cvs, 0, 0, w, h);
        return out.toDataURL('image/jpeg', 0.85);
      } catch (e) { return null; }
    }
    // 1) Amorf giydirme sonucu — crossOrigin temiz canvas'tan alınan gerçek texture+şekil
    //    (ozel-olcu-plus.js doUpdate() sonrasında window.__amorfLastPreviewDataUrl'e yazılır)
    if (window.__amorfLastPreviewDataUrl && window.__amorfLastPreviewDataUrl.length > 100) {
      return window.__amorfLastPreviewDataUrl;
    }
    // 2) Galeri img zaten data:image içeriyorsa (amorf update galeri src'yi değiştiriyor)
    var galleryImg = document.querySelector('.hdt-slider__slide img, .hdt-product__media-item img, .product__media img');
    if (galleryImg && galleryImg.src && galleryImg.src.substring(0, 10) === 'data:image') {
      return galleryImg.src;
    }
    // 3) Amorf şekil canvas (texture yok ama fallback olarak yine de dene)
    var amorfCvs = document.querySelector('#ozel-olcu-amorf-canvas');
    var url = fromCanvas(amorfCvs);
    if (url) return url;
    // 4) Plus/dikdörtgen motorunun helper'ı
    try {
      var op = window.__ozelOlcuPreview;
      if (op && typeof op.getPreviewDataUrl === 'function') {
        var d = op.getPreviewDataUrl(maxW);
        if (d && d.length > 100) return d;
      }
    } catch (e) {}
    // 3) Sayfada bulunan herhangi bir preview canvas
    var anyCvs = document.querySelector('canvas[id*="ozel-olcu"], canvas[class*="ozel-olcu"], .ozel-olcu-preview canvas, #preview-canvas');
    url = fromCanvas(anyCvs);
    if (url) return url;
    // 4) Plus motoru CDN cart preview
    try {
      var op2 = window.__ozelOlcuPreview;
      if (op2 && typeof op2.getCartPreviewUrl === 'function') {
        var cdn = op2.getCartPreviewUrl();
        if (cdn) return cdn;
      }
    } catch (e) {}
    // 5) En son çare: ana ürün görseli (clip yok ama hiç yoksa bu)
    var mainImg = document.querySelector('#bp-main-image img, .product__media img, .product-media img');
    if (mainImg) return mainImg.currentSrc || mainImg.src || null;
    return null;
  }

  function buildShapeSvg(st) {
    var W = 220, H = 160, pad = 18;
    var biye = st.kumasColor || '#e8622a';
    var fill = '#f5f0e8';
    var stroke = biye;
    var strokeW = 6;
    var w = st.widthCm || 200;
    var l = st.lengthCm || 160;
    // En-boy oranı SVG'ye sığdır
    var maxW = W - pad * 2, maxH = H - pad * 2;
    var ratio = w / l;
    var sw = maxW, sh = maxW / ratio;
    if (sh > maxH) { sh = maxH; sw = maxH * ratio; }
    var x = (W - sw) / 2, y = (H - sh) / 2;
    var shapeEl = '';
    var shape = st.shape || 'dikdortgen';
    if (shape === 'amorf' && st.amorf && st.amorf.radii && st.amorf.radii.length >= 3) {
      shapeEl = amorfPath(st.amorf.radii, x + sw / 2, y + sh / 2, Math.min(sw, sh) / 2 * 0.95, fill, stroke, strokeW);
    } else if (shape === 'daire') {
      var r = Math.min(sw, sh) / 2;
      shapeEl = '<circle cx="' + (W / 2) + '" cy="' + (H / 2) + '" r="' + r + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + strokeW + '"/>';
    } else if (shape === 'oval') {
      shapeEl = '<ellipse cx="' + (W / 2) + '" cy="' + (H / 2) + '" rx="' + (sw / 2) + '" ry="' + (sh / 2) + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + strokeW + '"/>';
    } else {
      shapeEl = '<rect x="' + x + '" y="' + y + '" width="' + sw + '" height="' + sh + '" rx="6" ry="6" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + strokeW + '"/>';
    }
    // Pattern fill: ürün resmi varsa pattern olarak kullan
    var defs = '';
    if (st.patternImg) {
      defs = '<defs><pattern id="dvpat" patternUnits="userSpaceOnUse" width="' + Math.min(sw, sh) + '" height="' + Math.min(sw, sh) + '">' +
        '<image href="' + esc(st.patternImg) + '" x="0" y="0" width="' + Math.min(sw, sh) + '" height="' + Math.min(sw, sh) + '" preserveAspectRatio="xMidYMid slice"/></pattern></defs>';
      shapeEl = shapeEl.replace('fill="' + fill + '"', 'fill="url(#dvpat)"');
    }
    // Ölçü etiketleri
    var labels =
      '<text x="' + (W / 2) + '" y="' + (y - 4) + '" text-anchor="middle" font-size="10" fill="#888" font-family="system-ui,sans-serif">' + w + ' cm</text>' +
      '<text x="' + (x - 6) + '" y="' + (H / 2) + '" text-anchor="end" dominant-baseline="middle" font-size="10" fill="#888" font-family="system-ui,sans-serif">' + l + ' cm</text>';
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" class="amorf-save-svg" xmlns="http://www.w3.org/2000/svg">' +
      defs + shapeEl + labels +
    '</svg>';
  }

  // Amorf radii (8-12 değer) → smooth blob path (catmull-rom benzeri yumuşatma)
  function amorfPath(radii, cx, cy, baseR, fill, stroke, sw) {
    var n = radii.length;
    var pts = [];
    var rmax = Math.max.apply(null, radii) || 1;
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2 - Math.PI / 2;
      var r = baseR * (radii[i] / rmax);
      pts.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
    }
    var d = 'M ' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (var j = 0; j < n; j++) {
      var p0 = pts[(j - 1 + n) % n];
      var p1 = pts[j];
      var p2 = pts[(j + 1) % n];
      var p3 = pts[(j + 2) % n];
      var c1x = p1[0] + (p2[0] - p0[0]) / 6;
      var c1y = p1[1] + (p2[1] - p0[1]) / 6;
      var c2x = p2[0] - (p3[0] - p1[0]) / 6;
      var c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ', ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ', ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    d += ' Z';
    return '<path d="' + d + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + sw + '" stroke-linejoin="round"/>';
  }

  function shapeIcon(s) {
    return ({ amorf: '✦', dikdortgen: '▭', oval: '◯', daire: '●' })[s] || '◆';
  }

  function shapeName(s) {
    return ({ amorf: 'Amorf', dikdortgen: 'Dikdörtgen', oval: 'Oval', daire: 'Yuvarlak' })[s] || s;
  }
  function edgeName(e) {
    return ({ biye: 'Biye', bordur: 'Bordür', overlok: 'Overlok' })[e] || e;
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function bindModal(wrap, st) {
    wrap.querySelector('.amorf-save-modal__close').addEventListener('click', closeModal);
    wrap.querySelector('.amorf-save-modal__backdrop').addEventListener('click', closeModal);

    // Kanal değişimi → tel/mail göster/gizle
    var radios = wrap.querySelectorAll('input[name="kanal"]');
    var telWrap = wrap.querySelector('[data-need="sms"]');
    var mailWrap = wrap.querySelector('[data-need="mail"]');
    function updateChannel() {
      var v = (wrap.querySelector('input[name="kanal"]:checked') || {}).value || 'sms';
      telWrap.style.display = (v === 'sms' || v === 'both') ? '' : 'none';
      mailWrap.style.display = (v === 'mail' || v === 'both') ? '' : 'none';
    }
    radios.forEach(function (r) { r.addEventListener('change', updateChannel); });
    updateChannel();

    // Telefon formatla — silme sırasında format uygulama (kullanıcı rahat silsin)
    var telEl = wrap.querySelector('input[name="tel"]');
    if (telEl) {
      telEl.addEventListener('input', function (e) {
        // Silme/kesme eylemlerinde formatı sıfırlama, kullanıcının yazdığını koru
        if (e.inputType && e.inputType.indexOf('delete') === 0) return;
        var d = this.value.replace(/\D/g, '').slice(0, 11);
        // 0 ile başlamıyorsa otomatik ekle (5XX, 4XX gibi)
        if (d.length > 0 && d[0] !== '0') d = '0' + d.slice(0, 10);
        var out = '';
        if (d.length <= 4)        out = d;
        else if (d.length <= 7)   out = d.slice(0,4) + ' ' + d.slice(4);
        else if (d.length <= 9)   out = d.slice(0,4) + ' ' + d.slice(4,7) + ' ' + d.slice(7);
        else                       out = d.slice(0,4) + ' ' + d.slice(4,7) + ' ' + d.slice(7,9) + ' ' + d.slice(9);
        if (out !== this.value) this.value = out;
      });
    }

    // Submit
    wrap.querySelector('#amorf-save-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var f = e.target;
      var err = wrap.querySelector('#amorf-save-err');
      err.textContent = '';

      var ad = f.ad.value.trim();
      var soyad = f.soyad.value.trim();
      var kanal = (f.kanal.value || 'sms');
      var tel = f.tel ? f.tel.value.replace(/\D/g, '') : '';
      var mail = f.mail ? f.mail.value.trim() : '';
      var consent = f.consent.checked;

      if (!ad || !soyad) { err.textContent = 'Ad ve soyad zorunludur.'; return; }
      if (kanal === 'sms' || kanal === 'both') {
        if (!tel || tel.length < 10) { err.textContent = 'Geçerli bir cep telefonu girin.'; return; }
        if (tel[0] !== '0') { err.textContent = 'Numara 0 ile başlamalıdır — örn: 0532 XXX XX XX'; return; }
      }
      if ((kanal === 'mail' || kanal === 'both') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) { err.textContent = 'Geçerli bir e-posta adresi girin.'; return; }
      if (!consent) { err.textContent = 'Devam etmek için onay vermelisiniz.'; return; }

      try {
        sessionStorage.setItem(SS_KEY_USER, JSON.stringify({ ad: ad, soyad: soyad, tel: tel, mail: mail }));
      } catch (e2) {}

      var btn = wrap.querySelector('.amorf-save-submit');
      btn.disabled = true; btn.textContent = 'Gönderiliyor...';
      showLoadingScreen(wrap, st);

      var payload = {
        ad: ad, soyad: soyad, tel: tel, mail: mail, kanal: kanal,
        state: st,
        pageUrl: location.href
      };

      fetch(API_BASE + '/save-design', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || !res.d || res.d.error) {
            throw new Error((res.d && res.d.error) || 'Gönderim başarısız');
          }
          hideLoadingScreen(wrap);
          renderSuccess(wrap, res.d, kanal);
        })
        .catch(function (er) {
          hideLoadingScreen(wrap);
          // Loading kapatildi — orijinal form'a don
          var box = wrap.querySelector('.amorf-save-modal__box');
          if (box && __loadingState && __loadingState.savedHtml) box.innerHTML = __loadingState.savedHtml;
          // err element kayip oldugu icin alert ile goster
          alert(er.message || 'Gönderim sırasında bir hata oluştu.');
        });
    });
  }


  // ═══ Premium loading screen — sunucu yanitini bekle ═══
  var __loadingState = null;
  function showLoadingScreen(wrap, st) {
    var box = wrap.querySelector('.amorf-save-modal__box');
    if (!box) return;
    var savedHtml = box.innerHTML;

    // Tip rotation messages
    // Tek mesaj — rotation yok
    var TIP_TEXT = 'Her tasarım benzersiz — sadece sizin için';

    // Tasarim ozeti
    var sumRows = [];
    if (st.title) sumRows.push(['Halı', st.title]);
    if (st.shape) {
      var shapeMap = { amorf: 'Amorf', dikdortgen: 'Dikdörtgen', oval: 'Oval', daire: 'Yuvarlak' };
      sumRows.push(['Şekil', shapeMap[st.shape] || st.shape]);
    }
    if (st.widthCm && st.lengthCm) sumRows.push(['Ölçü', st.widthCm + ' × ' + st.lengthCm + ' cm']);
    if (st.edgeType) {
      var edgeMap = { biye: 'Biye', bordur: 'Bordür', overlok: 'Overlok' };
      var edgeTxt = edgeMap[st.edgeType] || st.edgeType;
      if (st.kumasLabel) edgeTxt += ' · Kumaş ' + st.kumasLabel;
      sumRows.push(['Kenar', edgeTxt]);
    }
    var summaryHtml = sumRows.map(function(r){
      return '<div class="amorf-save-loading__sum-row"><span>' + r[0] + '</span><strong>' + r[1] + '</strong></div>';
    }).join('');

    // Hali gorseli — onceden yakalanmis previewImg veya patternImg
    var rugSrc = st.previewImg || st.patternImg || '';
    var rugImg = rugSrc ? '<img src="' + rugSrc + '" alt="" class="amorf-save-loading__rug" onerror="this.style.background=\'linear-gradient(135deg,#e8dcc8,#d4c4a8)\';this.removeAttribute(\'src\');">' : '<div class="amorf-save-loading__rug" style="background:linear-gradient(135deg,#e8dcc8,#d4c4a8);"></div>';

    box.innerHTML =
      '<div class="amorf-save-loading">' +
        '<div class="amorf-save-loading__inner">' +
          '<div class="amorf-save-loading__preview-wrap">' +
            '<div class="amorf-save-loading__preview">' + rugImg + '</div>' +
            '<div class="amorf-save-loading__shadow"></div>' +
          '</div>' +
          '<h2 class="amorf-save-loading__title">Tasarımınız Hazırlanıyor</h2>' +
          '<div class="amorf-save-loading__tip">' + TIP_TEXT + '</div>' +
          '<div class="amorf-save-loading__progress">' +
            '<div class="amorf-save-loading__step" data-step="1"><span class="amorf-save-loading__step-icon">○</span><span>Şekil oluşturuluyor</span></div>' +
            '<div class="amorf-save-loading__step" data-step="2"><span class="amorf-save-loading__step-icon">○</span><span>Kumaş işleniyor</span></div>' +
            '<div class="amorf-save-loading__step" data-step="3"><span class="amorf-save-loading__step-icon">○</span><span>Yüksek çözünürlük render</span></div>' +
            '<div class="amorf-save-loading__step" data-step="4"><span class="amorf-save-loading__step-icon">○</span><span>Linkiniz hazırlanıyor</span></div>' +
          '</div>' +
          (sumRows.length ? '<div class="amorf-save-loading__summary">' + summaryHtml + '</div>' : '') +
        '</div>' +
      '</div>';

    var steps = box.querySelectorAll('.amorf-save-loading__step');
    var tipEl = box.querySelector('.amorf-save-loading__tip');

    // Step 1 baslangic
    steps[0].classList.add('amorf-save-loading__step--active');
    steps[0].querySelector('.amorf-save-loading__step-icon').textContent = '●';

    // Step transition timer'lari
    var timeouts = [];
    timeouts.push(setTimeout(function(){
      steps[0].classList.remove('amorf-save-loading__step--active');
      steps[0].classList.add('amorf-save-loading__step--done');
      steps[0].querySelector('.amorf-save-loading__step-icon').textContent = '✓';
      steps[1].classList.add('amorf-save-loading__step--active');
      steps[1].querySelector('.amorf-save-loading__step-icon').textContent = '●';
    }, 1000));
    timeouts.push(setTimeout(function(){
      steps[1].classList.remove('amorf-save-loading__step--active');
      steps[1].classList.add('amorf-save-loading__step--done');
      steps[1].querySelector('.amorf-save-loading__step-icon').textContent = '✓';
      steps[2].classList.add('amorf-save-loading__step--active');
      steps[2].querySelector('.amorf-save-loading__step-icon').textContent = '●';
    }, 2000));
    timeouts.push(setTimeout(function(){
      steps[2].classList.remove('amorf-save-loading__step--active');
      steps[2].classList.add('amorf-save-loading__step--done');
      steps[2].querySelector('.amorf-save-loading__step-icon').textContent = '✓';
      steps[3].classList.add('amorf-save-loading__step--active');
      steps[3].querySelector('.amorf-save-loading__step-icon').textContent = '●';
      // Step 4 sunucu cevabini bekler — pulse animation
    }, 3000));

    // Tip rotation YOK — sabit mesaj
    __loadingState = { savedHtml: savedHtml, timeouts: timeouts, tipInterval: null };
  }

  function hideLoadingScreen(wrap) {
    if (!__loadingState) return;
    __loadingState.timeouts.forEach(clearTimeout);
    if (__loadingState.tipInterval) clearInterval(__loadingState.tipInterval);
    __loadingState = null;
  }

  function renderSuccess(wrap, d, kanal) {
    var box = wrap.querySelector('.amorf-save-modal__box');
    var sentTo = [];
    if ((kanal === 'sms' || kanal === 'both') && d.smsOk) sentTo.push('📱 SMS');
    if ((kanal === 'mail' || kanal === 'both') && d.mailOk) sentTo.push('✉️ E-posta');
    var sentTxt = sentTo.length ? sentTo.join(' + ') : 'kayıtlı kanallar';

    box.innerHTML =
      '<button type="button" class="amorf-save-modal__close" aria-label="Kapat">×</button>' +
      '<div class="amorf-save-success">' +
        '<div class="amorf-save-modal__brand" style="margin-bottom:10px;">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/dolce-vita-logo.png" alt="Dolce Vita Halı" class="amorf-save-modal__brand-logo">' +
        '</div>' +
        '<div class="amorf-save-success__ic">✓</div>' +
        '<div class="amorf-save-success__title">Tasarımın gönderildi!</div>' +
        '<p class="amorf-save-success__body">Aşağıdaki linki <b>' + esc(sentTxt) + '</b> adresine ilettik. İstediğin zaman bu linkten aynı tasarımı açabilir, sepete ekleyebilirsin.</p>' +
        '<div class="amorf-save-success__link">' +
          '<input type="text" readonly value="' + esc(d.shareUrl || '') + '" id="amorf-save-share-url">' +
          '<button type="button" id="amorf-save-copy">Kopyala</button>' +
        '</div>' +
        '<p class="amorf-save-success__note">Link 90 gün geçerlidir. Spam/gereksiz klasörünü de kontrol et.</p>' +
        '<button type="button" class="amorf-save-submit" id="amorf-save-done">Tamam</button>' +
        '<div class="amorf-save-modal__powered" style="margin-top:16px;">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/dolce-vita-logo.png" alt="Dolce Vita Halı" class="amorf-save-modal__powered-logo">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/massimo-logo.png" alt="Massimo" class="amorf-save-modal__powered-logo">' +
          '<img src="https://cdn.shopify.com/s/files/1/0511/6257/9115/t/462/assets/dolce-vita-home-logo.png" alt="Dolce Vita Home" class="amorf-save-modal__powered-logo">' +
        '</div>' +
      '</div>';
    box.querySelector('.amorf-save-modal__close').addEventListener('click', closeModal);
    box.querySelector('#amorf-save-done').addEventListener('click', closeModal);
    box.querySelector('#amorf-save-copy').addEventListener('click', function () {
      var inp = box.querySelector('#amorf-save-share-url');
      inp.select();
      try { document.execCommand('copy'); this.textContent = 'Kopyalandı ✓'; } catch (e) {}
    });
  }

  // -------------------- INIT --------------------
  function init() {
    // Sadece /products/ sayfalarında çalış
    if (location.pathname.indexOf('/products/') !== 0) return;
    injectFab();
    tryRestoreFromUrl();
    // Auto-show kapatıldı — modal sadece FAB butonuna tıklayınca açılır
    console.log('[AmorfSaveDesign] v1.0 yüklendi');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
